import React from "react";
import ReactDOM from "react-dom";
import "./css/webflow.css";
import "./index.css";
import "./css/normalize.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { IntercomProvider } from "react-use-intercom";
import { Provider } from "react-redux";
import store from "./store";

ReactDOM.render(
  <React.StrictMode>
    <IntercomProvider appId={process.env.REACT_APP_INTERCOM_APP_ID}>
      <Provider store={store}>
        <App />
      </Provider>
    </IntercomProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
